module.exports = __webpack_public_path__ + "img/kei_old.dabc4ac2.gif";